export const NotFoundLayout = () => {
    return <div>Not found</div>
}